import React from 'react';
import { ImportOutlined, MailOutlined } from '@ant-design/icons';

import BouncedEmailsContainer from '@totem/components/administration/bouncedEmails/BouncedEmailsContainer';
import {
  BouncedEmailsExtra,
  BouncedEmailsLayout,
} from '@totem/components/administration/bouncedEmails/BouncedEmailsLayout';
import { bouncedEmailsContainerConfiguration } from '@totem/components/administration/bouncedEmails/containerConfiguration';
import { logSyncContainerConfiguration } from '@totem/components/administration/logSync/containerConfiguration';
import LogSyncContainer from '@totem/components/administration/logSync/LogSyncContainer';
import {
  LogSyncExtra,
  LogSyncLayout,
} from '@totem/components/administration/logSync/LogSyncLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminLogManagement = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'bouncedEmails',
      title: 'Bounced Emails',
      label: 'Bounced Emails',
      description: 'SendGrid Invalid Address Review',
      route: '/dashboard/admin/bouncedEmails',
      content: (
        <InputContainer
          filterConfig={bouncedEmailsContainerConfiguration}
          defaultSort={{ field: 'updatedAt', direction: 'descend' }}
          defaultPageSize={20}
          componentKey={'dashboard.admin.bouncedEmails'}
          componentLabel={'Admin: Bounced Emails'}
        >
          <BouncedEmailsContainer>
            <IBCard
              isCovered
              title="Bounced Emails"
              extra={<BouncedEmailsExtra />}
            >
              <BouncedEmailsLayout />
            </IBCard>
          </BouncedEmailsContainer>
        </InputContainer>
      ),
      icon: <MailOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'logSync',
      title: 'Log Sync',
      label: 'Log Sync',
      description: 'Log Sync Result History',
      route: '/dashboard/admin/logSync',
      content: (
        <InputContainer
          filterConfig={logSyncContainerConfiguration}
          defaultSort={{ field: 'createdAt', direction: 'descend' }}
          defaultPageSize={20}
          componentKey={'dashboard.admin.logSync'}
          componentLabel={'Admin: Log Sync Results'}
        >
          <LogSyncContainer>
            <IBCard isCovered title="Log Sync Results" extra={<LogSyncExtra />}>
              <LogSyncLayout />
            </IBCard>
          </LogSyncContainer>
        </InputContainer>
      ),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
